var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { createStyles, withStyles } from "@material-ui/core/styles";
import Pagination from "@material-ui/lab/Pagination";
var styles = createStyles({
    root: {
        flexShrink: 0,
    },
});
export var TablePaginationActions = withStyles(styles, {
    name: "EuiTablePaginationActions",
})(React.forwardRef(function TablePaginationActions(_a, ref) {
    var backIconButtonProps = _a.backIconButtonProps, // eslint-disable-line
    nextIconButtonProps = _a.nextIconButtonProps, // eslint-disable-line
    onChangePage = _a.onChangePage, // eslint-disable-line
    count = _a.count, onPageChange = _a.onPageChange, page = _a.page, rowsPerPage = _a.rowsPerPage, props = __rest(_a, ["backIconButtonProps", "nextIconButtonProps", "onChangePage", "count", "onPageChange", "page", "rowsPerPage"]);
    return (React.createElement(Pagination, __assign({}, props, { ref: ref, count: Math.ceil(count / rowsPerPage), 
        // `TablePagination` is zero-based, while `Pagination` is 1-based
        onChange: function (_event, page) { return onPageChange(null, page - 1); }, page: page + 1 })));
}));
//# sourceMappingURL=TablePaginationActions.js.map